import React from 'react';
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';

const useStyles = {
    text: {
        color: 'text.primary',
        fontSize: '1rem',
    },
    bold: {
        fontWeight: "bold",
    },
    italic: {
        fontStyle: 'italic',
    },
    underline: {
        textDecoration: 'underline',
    }
}

const ShortTandC = () => {

    const classes = useStyles;

    return (
        <Grid container spacing={1} sx={classes.text}>
            <Grid style={{textAlign: 'center'}} size={12}>
                <Typography variant='h6' sx={classes.bold}>
                    {'CitePayUSA Payment Terms & Conditions'}
                </Typography>
            </Grid>
            <Grid size={12}>
                CitePayUSA, a services offering of Justice Systems, Inc. ("CitePayUSA"),
                provides services to you subject to the following terms and conditions:
            </Grid>
            <Grid size={12}>
                CitePayUSA charges a Payment Service Fee to use its service to make the payment of
                fines, fees and other obligations. This fee is separate from the primary
                obligation you are paying. The Payment Service Fee is included in the
                Amount that is displayed on the screen where you enter your payment account information.
                This Payment Service Fee is non-refundable.
            </Grid>
            <Grid size={12}>
                Completion of a payment transaction is contingent upon both the authorization
                of payment by your card company or bank and acceptance of your payment by the governmental
                authority or other entity you are paying. In the event your payment is not processed
                or authorized by your card company or bank, or the applicable entity you are seeking to pay
                fails to accept your payment, your payment liability shall remain outstanding and
                unpaid and you will be subject to all applicable penalties, late fees and interest
                charges assessed by the relevant entity thereon.
            </Grid>
            <Grid size={12}>
                You may be responsible for fees and administrative costs related to payments you
                dispute and imposed by the governmental authority and or CitePayUSA. All or any of
                these obligations remain your sole responsibility.
            </Grid>
            <Grid size={12}>
                By checking the <Typography component='span' sx={classes.italic}>"I agree to the CitePayUSA Payment Terms and Conditions"</Typography>
                box, you hereby confirm your acceptance of the Payment Service Fee charged by CitePayUSA
                and agree to pay the Amount indicated, subject to and in
                accordance with the agreement governing the use of your credit or debit card.
            </Grid>
            <Grid size={12}>
                By visiting or using this web site you agree to these terms and conditions and we
                request that you read them carefully before proceeding. CitePayUSA is not responsible
                for any fees or other charges associated with your access to the Internet, the
                devices and networks used, nor the security of the information you transmit by use of
                those local devices.
            </Grid>
            <Grid size={12}>
                Please read the other Terms and Conditions associated with the use of this web site
                and payments made through CitePayUSA by clicking on the
                <Typography component='span' sx={classes.underline}>Terms and Conditions</Typography> link.
            </Grid>
        </Grid>
    );
};

export default ShortTandC;